import React from 'react'
import PropTypes from 'prop-types'

import { FormWrapper, Input, Checkbox } from 'components';

import { Form, Modal, Header, TransitionablePortal } from 'semantic-ui-react'

import { API } from 'services';
import { Typeof } from 'utils';

class ModalClinic extends React.Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.isEdit = Typeof.object(props.clinic);

    let state = {
      actions: {
        submit: {
          name: "Valider",
          callback: this.handleSubmit
        },
        cancel: {
          name: "Annuler",
          callback: props.onClose
        }
      },

      icon: 'add',
      title: 'Nouvelle clinique',
      clinic: {},
      method: API.post,
      route: '/clinics'
    };

    if(this.isEdit) {

      state = {
        ...state,
        icon: 'edit',
        title: 'Modification clinique',
        clinic: props.clinic,
        method: API.put,
        route: `/clinics/${props.clinic.id}`
      };
    }

    this.state = state;
  }

  handleSubmit(data, onSucess, onError) {

    this.state.method(this.state.route, data)
      .then((response) => {
        this.props.onClose(response.data);
      })
      .catch((error) => {
        onError(API.violations(error));
      });
  }

  render() {

    return (
      <TransitionablePortal open transition={{ animation: "fade down", duration: 250 }}>
        <Modal open size='small'>
          <Header icon={this.state.icon} content={this.state.title} />
          <Modal.Content>

            <FormWrapper actions={this.state.actions}>

              {/* Lastname */}
              <Form.Field>
                <label htmlFor="inputName" className="required">Nom</label>
                <Input id="inputName" name="name" value={this.state.clinic.name} />
              </Form.Field>

              <Form.Group widths='equal'>

                {/* Email */}
                <Form.Field>
                  <label htmlFor="inputEmail" className="required">Adresse e-mail</label>
                  <Input id="inputEmail" name="email" value={this.state.clinic.email} />
                </Form.Field>

                {/* Phone */}
                <Form.Field>
                  <label htmlFor="inputPhone" className="required">Numéro de téléphone</label>
                  <Input id="inputPhone" name="phone" value={this.state.clinic.phone} />
                </Form.Field>

              </Form.Group>

              {/* Address */}
              <Form.Field>
                <label htmlFor="inputAddress" className="required">Adresse</label>
                <Input id="inputAddress" name="address" value={this.state.clinic.address} />
              </Form.Field>

              <Form.Group widths='equal'>

                {/* Zip code */}
                <Form.Field>
                  <label htmlFor="inputZipCode" className="required">Code postal</label>
                  <Input id="inputZipCode" name="zip_code" value={this.state.clinic.zip_code} />
                </Form.Field>

                {/* City */}
                <Form.Field>
                  <label htmlFor="inputCity" className="required">Ville</label>
                  <Input id="inputCity" name="city" value={this.state.clinic.city} />
                </Form.Field>

              </Form.Group>

              {/* Expert */}
              <Form.Field>
                <Checkbox toggle label="Expert" name="expert" checked={this.state.expert} />
              </Form.Field>

            </FormWrapper>

          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    );
  }
}

ModalClinic.propTypes = {
  onClose: PropTypes.func.isRequired,
  clinic: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired
  })
};

export default ModalClinic;
